import React, { useEffect, useRef } from "react";
import herobgcover from "../../../../assets/images/herobgcover.png";
import { useInView } from "react-intersection-observer";
import scrolldown from "../../../../assets/icons/scrolldown.svg";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import {
    Fade,
    Hinge,
    JackInTheBox,
    Roll,
    Slide,
    Zoom,
} from "react-awesome-reveal";
import { Link } from "react-router-dom";

function Hero({
    setIsLargeScreen,
    isLargeScreen,
    isPage,
    setisPage,
    pageInView,
    setPageInView,
}) {
    const sceneRef = useRef(null);
    const imgRef = useRef(null);
    const { ref, inView, entry } = useInView({
        triggerOnce: false,
        threshold: 0.5,
    });
    useEffect(() => {
        if (inView) {
            console.log("pageview is mission");
            if (inView) {
                setPageInView("mission");
            }
        }
    }, [inView]);
    useEffect(() => {
        const handleScroll = () => {
            if (sceneRef.current && imgRef.current) {
                const scrollY = window.scrollY;
                const translateY = scrollY * -0.7;

                gsap.to(imgRef.current, {
                    y: translateY,
                    duration: 0.5,
                    ease: "power2.out",
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        gsap.registerPlugin(SplitText);
        const innovationpara = new SplitText("#innovationpara", {
            type: "words",
        });

        gsap.from(innovationpara.words, {
            duration: 3,
            opacity: 0,
            ease: "power1.inOut",
            stagger: {
                each: 0.13,
                from: "start",
            },
        });

        return () => {
            innovationpara.revert();
        };
    }, []);

    const handlePagination = (item, number) => {
        scrollToElement(item);
        setisPage(number);
    };
    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        console.log("clicked", id);
        if (element) {
            gsap.to(window, {
                scrollTo: {
                    y: element.offsetTop,
                    offsetY: -140,
                },
                ease: "power2.inOut",
            });
        }
    };
    return (
        <div
            ref={ref}
            id="mission"
            className="relative h-screen overflow-hidden text-center flex flex-col z-10 px-5 lg:px-10"
        >
            <img
                onClick={() => scrollToElement("secondpage")}
                src={scrolldown}
                className="absolute top-[90%] lg:top-[90%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer w-[40px] md:w-[60px] z-50"
                alt=""
            />
            <div className="pb-[60px] z-20 text-white relative w-full md:w-[90%] mx-auto mt-[120px] lg:mt-[140px] xl:mt-[200px] 2xl:mt-[200px] sm:mt-[140px] text-left">
                {isLargeScreen ? (
                    <div>
                        <div className="absolute h-[2000px] top-[-220px] inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                        <div className="absolute h-[2000px] top-[-220px] inset-y-0 left-1/3 w-px bg-white/10 z-0"></div>
                        <div className="absolute h-[2000px] top-[-220px] inset-y-0 left-2/3 w-px bg-white/10 z-0"></div>
                        <div className="absolute h-[2000px] top-[-220px] inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                    </div>
                ) : (
                    <div>
                        <div className="absolute h-[2000px] top-[-220px] inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                        <div className="absolute h-[2000px] top-[-220px] inset-y-0 left-1/2 w-px bg-white/10 z-0"></div>
                        <div className="absolute h-[2000px] top-[-220px] inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                        <div className="absolute h-[2000px] inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                        <div className="absolute h-[2000px] inset-y-0 left-1/2 w-px bg-white/10 z-0"></div>
                        <div className="absolute h-[2000px] inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                    </div>
                )}

                <div className="pt-0 md:pt-2 lg:pt-14 xl:pt-2 2xl:pt-24">
                    <Fade triggerOnce>
                        <h1 className="w-full sm:w-[90%] text-[45px] leading-[45px] md:text-[70px] md:leading-[70px] lg:text-[75px] lg:leading-[80px] xl:text-[95px] xl:leading-[90px] 2xl:text-[120px] 2xl:leading-[110px] ml-[-2px] xl:w-[1030px] 2xl:w-[1230px]">
                            {`GROW YOUR BUSINESS WITH SEO-OPTIMIZED WEBSITES`.toUpperCase()}
                        </h1>
                    </Fade>
                    <Fade triggerOnce>
                        <h5 className="mt-6 w-full lg:w-[50%] md:w-[95%] xl:w-[65%] 2xl:w-[35%] sm:w-full h12 text-[18px] leading-[27px] md:text-[24px] md:leading-[32px] lg:text-[24px] xl:text-[36px] lg:leading-[36px] 2xl:text-[36px] 2xl:leading-[42px]">
                            Reach more customers with websites built for Indian businesses. Our SEO-optimized solutions boost your Google rankings, drive local traffic, and convert visitors into customers—helping you dominate your market and grow revenue organically.
                        </h5>
                    </Fade>
                    <Fade triggerOnce>
                        <button 
                            onClick={() => scrollToElement("careers")}
                            className="mt-8 px-8 py-4 rounded-full bg-white text-black font-semibold text-[16px] md:text-[18px] rounded-lg hover:bg-white/90 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl w-fit"
                        >
                            GET FREE CONSULTATION
                        </button>
                    </Fade>
                    <Roll triggerOnce></Roll>
                </div>
            </div>
        </div>
    );
}

export default Hero;